import { css } from "@emotion/react";

export const backButtonWrapper = css`
  text-align: left;
  width: 100%;
`;

export const textWrapper = css`
  margin-bottom: 3rem;
  max-width: 42rem;
  text-align: center;
  overflow-wrap: anywhere;
`;
